import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "withdrawalType",
    "partialAmountSection",
    "contributionPaymentMode",
    "standingOrderSection",
    "paymentMethod",
    "eftBranchSection",
    "fullWithdrawalDocuments",
    "partialWithdrawalDocuments",
  ];

  connect() {
    this.updateFormSections();
  }

  withdrawalTypeChanged() {
    this.updateFormSections();
  }

  contributionPaymentModeChanged() {
    this.updateFormSections();
  }

  paymentMethodChanged() {
    this.updateFormSections();
  }

  updateFormSections() {
    const withdrawalType = this.getSelectedValue(this.withdrawalTypeTargets);
    const contributionMode = this.getSelectedValue(
      this.contributionPaymentModeTargets
    );
    const paymentMethod = this.getSelectedValue(this.paymentMethodTargets);

    // Show/hide partial amount section
    if (this.hasPartialAmountSectionTarget) {
      this.partialAmountSectionTarget.style.display =
        withdrawalType === "partial" ? "block" : "none";
    }

    // Show/hide standing order cancellation section
    if (this.hasStandingOrderSectionTarget) {
      const showStandingOrder =
        withdrawalType === "full" && contributionMode === "bank_standing_order";
      this.standingOrderSectionTarget.style.display = showStandingOrder
        ? "block"
        : "none";
    }

    // Show/hide EFT branch section
    if (this.hasEftBranchSectionTarget) {
      this.eftBranchSectionTarget.style.display =
        paymentMethod === "eft" ? "block" : "none";
    }

    // Show/hide document sections based on withdrawal type
    if (this.hasFullWithdrawalDocumentsTarget) {
      this.fullWithdrawalDocumentsTarget.style.display =
        withdrawalType === "full" ? "block" : "none";
    }

    if (this.hasPartialWithdrawalDocumentsTarget) {
      this.partialWithdrawalDocumentsTarget.style.display =
        withdrawalType === "partial" ? "block" : "none";
    }
  }

  getSelectedValue(targets) {
    if (!targets) return null;

    for (const target of targets) {
      if (target.checked) {
        return target.value;
      }
    }
    return null;
  }
}
